import { InfoDialog } from './ui/info-dialog'

export const GeneratingHotkeyInfoDialog = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => (
  <InfoDialog
    isOpen={isOpen}
    onClose={onClose}
    title='Making complex trades simple'
    descriptions={[
      'Before Polaris, trading across networks meant juggling wallets, funding all sorts of different network fees, and manually approving every step.',
      'Now? Just activate your wallet, relax with a cup of coffee, and let Polaris handle it.',
      <h3
        key='how-does-it-work'
        className='mt-10 text-3xl font-serif font-extralight text-primary'
      >
        How does it work?
      </h3>,
      'This is where the magic happens. When you make a trade, you’re sending your funds to an auto-generated wallet behind the scenes. Then Autopilot kicks in and signs all the transactions between your source and destination wallets  — all while you keep full custody of your assets.',
    ]}
  />
)
